import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined
} from '@ant-design/icons';

import ApiService from "../services/ApiService"

import IntlMessage from "../components/util-components/IntlMessage";
import {API_BASE_URL} from "../configs/AppConfig";
import ModalPromesse from "./ModalPromesse";
import ModalPayement from "./ModalPayement";
import ResponsiveTable from "../components/ResponsiveTable";
import ModalContact from "./ModalContact";


const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalUser extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    state = {
        visible: false,
        loading: false,
        data: null,
    };

    async show(id) {
        console.log("USER ", id)

        this.setState({visible: true, loading: true})

        var res = await ApiService.get("/users/" + id)
        console.log(res)

        if (res.success) {
            this.setState({loading: false, data: res.compte})
        } else {
            this.close()
        }

    }

    close() {
        this.setState({
            visible: false,
            loading: false,
            data: null,
        })
    }


    render() {

        var MENU = [
            {
                label: <a href="#" onClick={() => this.modalPayement.show(this.state.data?.id)}>Enregistrer un
                    Paiement</a>,
                key: '0',
            },
            {
                label: <a href="#" onClick={() => this.modalPromesse.show(this.state.data?.id)}>Créer une Promesse de
                    don</a>,
                key: '1',
            },
        ]

        if (this.state.data?.contact) {
            MENU.push({
                label: <a href="#" onClick={() => this.modalContact.show(this.state.data.contact)}>Fiche Contact</a>,
                key: '2',
            },)
        }

        var table = [
            {
                title: 'Nom',
                dataIndex: 'nom',
                width: '20%',
            },
            {
                title: 'Prénom',
                dataIndex: 'prenom',
                width: '20%',
            },
            {
                title: 'Email',
                dataIndex: 'email',
            },
            {
                title: 'Téléphone',
                dataIndex: 'tel',
            },

            {
                title: 'Action',
                render: (col, row) => {
                    return (
                        <Dropdown overlay={
                            <Menu
                                items={MENU}
                            />
                        } trigger={['click']}>
                            <a onClick={(e) => e.preventDefault()}>
                                <Space>
                                    Actions
                                    <DownOutlined/>
                                </Space>
                            </a>
                        </Dropdown>
                    )
                },
            },
        ];
        //console.log(this.state.link)

        return (
            <Fragment>
                <Modal width={"100%"} title={"Index Utilisateur"} open={this.state.visible} destroyOnClose closable
                       footer={null} onCancel={() => this.close()}>

                    <ResponsiveTable
                        scroll={{x: "100%"}}
                        columns={table}
                        rowKey={(record, index) => index}
                        dataSource={[this.state.data]}
                        loading={this.state.loading}
                        pagination={false}
                        bordered
                    />

                </Modal>
                <ModalPromesse getRef={(ref) => this.modalPromesse = ref} onFinish={() => {
                }}/>
                <ModalPayement getRef={(ref) => this.modalPayement = ref} onFinish={() => {
                }}/>
                <ModalContact getRef={(ref) => this.modalContact = ref} onFinish={() => {
                }}/>
            </Fragment>

        )
    }
}

